import { Navigate } from "react-router-dom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { PrivateRoutes } from "./PrivateRoutes";
import { PublicRoutes } from "./PublicRoutes";
import { CustomerRoutes } from "./CustomerRoutes";

const router = createBrowserRouter([
  ...PrivateRoutes,
  ...PublicRoutes,
  ...CustomerRoutes,
  {
    path: "*",
    element: <Navigate to="/" replace />
  }
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router; 